import { render, staticRenderFns } from "./WalletSetupComponent.vue?vue&type=template&id=34a014b4&scoped=true&"
import script from "./WalletSetupComponent.vue?vue&type=script&lang=js&"
export * from "./WalletSetupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a014b4",
  null
  
)

export default component.exports